import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Card,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import CustomNavbar from "../../components/CustomNavbar";
import CustomTable from "../../components/CustomTable";
import CustomPagint from "../../components/CustomPagint";
import messages from "../../redux/messages";
import SidebarConfig from "../../components/SidebarConfig";
import {
  get_tasks,
  saveTask,
  editTask,
  deleteTask,
} from "../../redux/tasks/actions";
import * as Yup from "yup";
import { Formik } from "formik";

const Tasks = (props) => {
  const schema = Yup.object().shape({
    codigo: Yup.string().required("**Campo requerido"),
    nombre: Yup.string().required("**Campo requerido"),
    descripcion: Yup.string().required("**Campo requerido"),
  });

  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState("");
  const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(false);
  //Redux
  const dispatch = useDispatch();
  const { tasks, tasksLength, loader, saveLoader, tasksError, formError } =
    useSelector((store) => store.tasks);
  const pages = Math.ceil(tasksLength / limit);

  const columns = [
    {
      Header: "Código",
      accessor: "codigo",
    },
    {
      Header: "Nombre",
      accessor: "nombre",
    },
    {
      Header: "Descripción",
      accessor: "descripcion",
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            type="button"
            onClick={() => onDelete(value.row.original.id, value.row.index)}
          >
            <i className="material-icons">close</i>
          </Button>
        </div>
      ),
    },
  ];

  // Métodos
  const getATasks = (offs = offset, lim = limit, filt = filter) =>
    dispatch(
      get_tasks(
        {
          offset: offs,
          limit: lim,
          filter: filt,
        },
        parseInt(props.match.params.type)
      )
    );

  useEffect(() => {
    getATasks();
  }, [props.match.params.type]);

  const onAdd = () => {
    setShowModal(true);
    setEdit(false);
    setValidated(false);
  };

  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
    setValidated(false);
  };

  const onSearch = (e) => {
    e.preventDefault();
    if (!e.target.filter.value.trim()) {
      return;
    }
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    getATasks(oOffset, limit, e.target.filter.value);
  };

  const onSubmit = (req) => {
    if (!edit) {
      dispatch(saveTask(req, parseInt(props.match.params.type), setShowModal));
    } else {
      dispatch(
        editTask(
          req,
          editItem.id,
          index,
          parseInt(props.match.params.type),
          setShowModal
        )
      );
    }
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    setCurrentPage(1);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    getATasks(oOffset, limit, oSearch);
  };

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteTask(id, index, parseInt(props.match.params.type)));
    }
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarConfig show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <div className="container-fluid">
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h5 className="font-weight-bold text-uppercase">
              {parseInt(props.match.params.type) === 1 ? "Formal" : "Funcional"}{" "}
              Funciones
            </h5>
            <Form onSubmit={onSearch}>
              <Row className="justify-content-end align-items-center flex-nowrap">
                <Col xs="auto">
                  <Form.Control
                    id="filter"
                    name="filter"
                    //onChange={ e => setFilter(e.target.value)}
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    type="search"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      onClick={() => seeAll()}
                      variant="light"
                      size="sm"
                      className="rounded-circle mr-1"
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-circle"
                      onClick={() => onAdd()}
                    >
                      <i className="material-icons">add</i>
                    </Button>
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          {loader ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : (
            tasks.length > 0 && (
              <>
                <Card className="border-0">
                  <Card.Body className="px-1 px-sm-2">
                    <CustomTable columns={columns} data={tasks} />
                  </Card.Body>
                </Card>
                <CustomPagint
                  limit={limit}
                  setLimit={setLimit}
                  offset={offset}
                  setOffset={setOffset}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  dataLenght={tasksLength}
                  pages={pages}
                  pagFunc={getATasks}
                />
              </>
            )
          )}
          {!loader && tasks.length === 0 && tasksError === "" && (
            <Alert className="my-4" variant="info">
              Aún no hay funciones registradas, comienza a agregando algunas
            </Alert>
          )}
          {!loader && !!tasksError && (
            <Alert variant="danger" className="my-4">
              {tasksError}
            </Alert>
          )}
        </div>
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Formik
          validationSchema={schema}
          onSubmit={onSubmit}
          initialValues={{
            codigo: edit ? editItem.codigo : "",
            nombre: edit ? editItem.nombre : "",
            descripcion: edit ? editItem.descripcion : "",
          }}
        >
          {({
            handleSubmit,
            handleChange,
            setFieldValue,
            handleBlur,
            values,
            touched,
            isValid,
            errors,
          }) => (
            <Form onSubmit={handleSubmit} noValidate validated={validated}>
              <Modal.Header closeButton>
                <Modal.Title>
                  {edit ? "Editar función" : "Crear función"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!!formError && (
                  <Alert variant="danger" className="my-1">
                    {formError}
                  </Alert>
                )}
                <Form.Group as={Row} className="mb-3">
                  <Form.Label column sm="12" md="4">
                    Código
                  </Form.Label>
                  <Col sm="12" md="8">
                    <Form.Control
                      id="codigo"
                      name="codigo"
                      isInvalid={touched.codigo && errors.codigo}
                      isValid={touched.codigo && !errors.codigo}
                      onBlur={handleBlur("codigo")}
                      onChange={handleChange}
                      value={values.codigo}
                      className="rounded-pill"
                      type="text"
                      placeholder="Código"
                      // name="codigo"
                      // className="rounded-pill"
                      // required
                      // type="text"
                      // defaultValue={edit ? editItem.codigo : null}
                      // pattern="[A-Za-z0-9]+"
                      // placeholder="Código"
                    ></Form.Control>
                    {touched.codigo && errors.codigo && (
                      <div>
                        <small className="text-danger mx-2">
                          {errors.codigo}
                        </small>
                      </div>
                    )}
                    {/* <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                      **Solo admite números y letras
                    </Form.Control.Feedback> */}
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  <Form.Label column sm="12" md="4">
                    Nombre
                  </Form.Label>
                  <Col sm="12" md="8">
                    <Form.Control
                      id="nombre"
                      name="nombre"
                      isInvalid={touched.nombre && errors.nombre}
                      isValid={touched.nombre && !errors.nombre}
                      onBlur={handleBlur("nombre")}
                      onChange={handleChange}
                      value={values.nombre}
                      className="rounded-pill"
                      type="text"
                      placeholder="Nombre"
                      // name="nombre"
                      // className="rounded-pill"
                      // required
                      // type="text"
                      // defaultValue={edit ? editItem.nombre : null}
                      // pattern="[A-Za-zñÑáéíóúÁÉÍÓÚ0-9\s]+"
                      // placeholder="Descripción"
                    ></Form.Control>
                    {touched.nombre && errors.nombre && (
                      <div>
                        <small className="text-danger mx-2">
                          {errors.nombre}
                        </small>
                      </div>
                    )}
                    {/* <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                      **Solo admite números y letras
                    </Form.Control.Feedback> */}
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  <Form.Label column sm="12" md="4">
                    Descripción
                  </Form.Label>
                  <Col sm="12" md="8">
                    <Form.Control
                      id="descripcion"
                      name="descripcion"
                      isInvalid={touched.descripcion && errors.descripcion}
                      isValid={touched.descripcion && !errors.descripcion}
                      onBlur={handleBlur("descripcion")}
                      onChange={handleChange}
                      value={values.descripcion}
                      className="rounded"
                      as="textarea"
                      placeholder="Descripción"
                      // as="textarea"
                      // name="desc"
                      // required
                      // type="text"
                      // defaultValue={edit ? editItem.descripcion : null}
                      // pattern="[A-Za-zñÑáéíóúÁÉÍÓÚ0-9\s]+"
                      // placeholder="Descripción"
                    ></Form.Control>
                    {touched.descripcion && errors.descripcion && (
                      <div>
                        <small className="text-danger mx-2">
                          {errors.descripcion}
                        </small>
                      </div>
                    )}
                    {/* <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                      **Solo admite números y letras
                    </Form.Control.Feedback> */}
                  </Col>
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cerrar
                </Button>
                <Button
                  className="rounded-pill"
                  disabled={saveLoader}
                  variant="primary"
                  type="submit"
                >
                  {saveLoader ? (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : null}
                  Guardar
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default Tasks;
